export default __webpack_public_path__ + "static/media/discord-animated.371033b2.gif";